







































import CFMDialog from '@/scripts/CFMDialog'
import {Component} from 'vue-property-decorator';

import * as blockui from '@/helpers/block-ui'

import {required} from "vuelidate/lib/validators";

import {CFMDTOToolType } from '@/scripts/services/ClientApiAuto'

@Component<ToolTypeDialog>({
    validations() {
        return {
          toolType:{
              Name: {required}
          }
        }
    },
})
export default class ToolTypeDialog extends CFMDialog {
    toolType: CFMDTOToolType = {Name: ''};

    async created(){
      blockui.blockModal(this);
      if(this.isUpdate){
        const res = await this.apiClient.toolType.toolTypeGetById({id: <number>this.id});
        console.log(res);
        this.toolType = res.data;
      }
      blockui.unBlockModal();
    }

    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
          return;
      }
      let formData = {
        Id: this.toolType.Id,
        Name: this.toolType.Name,
      };
      blockui.blockModal(this);
      try{
        const response  = await this.apiClient.toolType.toolTypeSave(formData);
        if (response.data.IsSuccess) {
          toastr.success(this.translate('save_successfully'));
          this.saveSucceeded();
          this.close();
        } else {
          const errorMessage = response.data.Message ? response.data.Message : "Error";
          toastr.error(errorMessage);
        }
      }
      catch(e){
        console.log("err",e)
        toastr.error(e);
      }
      finally{
        blockui.unBlockModal();
      }
    }
}
